/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Tool_Start_Project_ChatInputs */



/**
* | output |
* | --- |
* | "Opening a chat" |
*
* @param {Uno_Tool_Start_Project_ChatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_tool_start_project_chat = /** @type {((inputs?: Uno_Tool_Start_Project_ChatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Tool_Start_Project_ChatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffne einen Chat")
	return /** @type {LocalizedString} */ ("Opening a chat")
});